import { useEffect, useState } from 'react';

import { getPaymentProvider } from './apiRequests';
import { notificationError } from '../../../core/actions';

/**
 * The payments backend's answer to "which processor does this merchant's next bank account use?"
 * -- 'SOLA', 'BLUESNAP', or null while it is still loading (or if it failed).
 *
 * Replaces reading merchant_config PAYMENT_PROVIDER here and treating a missing row as BlueSnap.
 * The backend's default is now SOLA, so that local guess would show BlueSnap's wizard to a
 * merchant the backend boards on Sola. Callers must treat null as "not known yet", never as a
 * provider.
 */
const usePaymentProvider = merchantId => {
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    if (!merchantId) {
      return undefined;
    }

    let current = true;
    setProvider(null);

    getPaymentProvider(merchantId)
      .then(result => {
        if (current) {
          setProvider(result);
        }
      })
      .catch(err => {
        console.log('### could not determine the payment provider', { err });
        if (current) {
          notificationError('Could not load payment settings. Please refresh.');
        }
      });

    return () => {
      current = false;
    };
  }, [merchantId]);

  return provider;
};

export default usePaymentProvider;
